import { DryerCategory, DryerType } from './dryer-model.model';

export interface DryerGroupDTO {
  dryerTypes: Map<DryerType, Set<DryerCategory>>;
}

export enum DryerGroup {
  REFRIGERATED_DRYERS = 'Refrigerated Dryers',
  DESICCANT_DRYERS = 'Desiccant Dryers',
  SUBFREEZING_DRYERS = 'Subfreezing Dryers',
  VSD_DRYERS = 'VSD Dryers',
}

export interface DryerGroupResponseDTO {
  dryerGroups: Map<DryerGroup, DryerGroupDTO>;
}
